// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-pages-contact----index-module---wrapper---1NuY2","innersub":"src-pages-contact----index-module---innersub---KAzyE"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/contact/index.module.css
// module id = 328
// module chunks = 189066279150898